import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Table } from 'primeng/table';
import { environment } from '../../../../environments/environment';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';

@Component({
  selector: 'app-banchmark',
  standalone: false,
  templateUrl: './banchmark.component.html',
  styleUrls: ['./banchmark.component.scss']
})
export class BanchmarkComponent implements OnInit {
  @Input() id: any;
  benchmarkForm: FormGroup;
  tecDataHeader: any[] = [];
  tecData: any[] = [];
  payload: any;
  isEditMode: boolean = false;
  existingBenchmarkId: any = null;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() routeConfig = new EventEmitter<any>();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @ViewChild('table') table: Table;
  benchmarkData: any;
  vendors: any;
  apiUrl = environment.APIUrl;
  JustificationForm: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  resId: any;
  @Input() schemeType: any; // Default to 'rev' if not provided
  vendorForm!: FormGroup;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  userID: any;
  benchmarkDates: any[] = [];
  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) {
    this.benchmarkForm = this.fb.group({
      // base_price: ['', Validators.required],
      // if_price: ['', Validators.required],
      benchmark_price: ['', Validators.required],
      bid_opening_date: ['', Validators.required],
      bid_opening_time: ['', Validators.required],
      technical_bid_venue: [''],
      comment: ['', Validators.required]
    });
    this.vendorForm = this.fb.group({
      vendor_name: ['', Validators.required],
      vendor_address: ['', Validators.required],
      benchmark_price: [null, [Validators.required, Validators.min(0)]],
      bid_opening_date: ['', Validators.required],
      bid_opening_time: ['', Validators.required],

      document: [null]
    });
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.payload = {
        proposal_id: params['id'],
        proposal_name: params['name']
      };
      this.fetchBenchmarkData();
    });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
         this.isEditorDisabled = false;
        this.benchmarkForm.enable();
      } else {
         this.isEditorDisabled = true;
        this.benchmarkForm.disable();
      }
    }, 3000);
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  addRow() {
    const newRow: any = { editable: true };
    this.tecDataHeader.forEach(header => newRow[header.key] = '');
    this.tecData.unshift(newRow);
  }
fullResponse:any;
fetchBenchmarkData() {
  console.log('🔥 fetchBenchmarkData called', this.id, this.payload);
 

  this.api.getAPI(
    `/revenue/benchmark-details/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
  ).subscribe({
    next: (res: any) => {

      console.log('✅ Full API Response:', res);
      

      // ✅ Handle empty response
      const data = res ;

      if (!data) {
        console.warn('⚠ No data found');
        this.resId = null;
        this.fullResponse = null;
        this.vendors = [];
        this.benchmarkDates = [];
        return;
      }

      // ✅ Store full response
      this.fullResponse = data;

      // ✅ Store ID
      this.resId = data.id;

      console.log('📌 Stored ID:', this.resId);

      // ✅ Vendors
      this.vendors = data.vendors || [];

      // ✅ Patch form
      this.benchmarkForm.patchValue({
        comment: data.justification || '',
        benchmark_price: data.base_price,
        bid_opening_date: data.bid_opening_date || '',
        bid_opening_time: data.bid_opening_time || '',
        technical_bid_venue: data.technical_bid_venue || ''
      });

      // ✅ Store benchmark price
      sessionStorage.setItem('benchmark', data.base_price || '');

      // ✅ Benchmark dates
      this.benchmarkDates = Array.isArray(data.benchmark_dates)
        ? data.benchmark_dates.map((row: any) => ({
            ...row,
            edit: false
          }))
        : [];

      console.log('📊 Final Stored Data:', {
        id: this.resId,
        full: this.fullResponse,
        vendors: this.vendors,
        dates: this.benchmarkDates
      });
    },

    error: (err) => {
      console.error('❌ API Error:', err);
    }
  });
}
  // saveBenchmarkData() {
  //   let payload = {
  //     proposal_step: this.step.id,
  //     benchmark_price: this.benchmarkForm.get('benchmark_price').value,
  //     justification: this.benchmarkForm.get('comment').value,

  //   }
  //   if (this.benchmarkData?.id) {
  //     this.api.putAPI(`/revenue/benchmark-details/${this.benchmarkData.id}/`, payload).subscribe((res: any) => {
  //       this.fetchBenchmarkData();
  //       this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'RFP updated successfully' });
  //     });
  //   } else {

  //     this.api.postAPI(`/revenue/benchmark-details/`, payload).subscribe((res: any) => {
  //       this.fetchBenchmarkData();
  //       this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'RFP uploaded successfully' });
  //     });
  //   }
  // }
  // editForm() {
  //   this.benchmarkForm.enable();
  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Info',
  //     detail: 'Form is now editable.',
  //   });
  // }
  ;
  // clonedVendors: { [s: number]: Vendor } = {};
  //  fetchVendors(): void {
  //   this.api.getAPI('/api/vendors').subscribe((data) => {
  //     this.vendors = data;
  //   });
  // }
  // onRowEditInit(rowData: any) {
  //  console.log(rowData)
  //   rowData.originalData = { ...rowData };
  // }

  // onRowEditSave(rowData: any) {
  //   console.log('Saved row:', rowData);

  //   // Optional: Upload file to server or handle locally
  //   if (rowData.uploadedFile) {
  //     console.log('File ready for upload:', rowData.uploadedFile.name);
  //     // Upload logic goes here
  //   }
  //    const formData = new FormData();
  //   formData.append('proposal_step', this.step.id);
  //   formData.append('vendor_id', rowData.vendor.id);
  //   formData.append('benchmark_price', rowData.benchmarkPrice);
  //   // formData.append('justification', rowData.justification);
  //   // formData.append('remark', rowData.remark);
  // formData.append('document', rowData.uploadedFile);
  //   // if (this.selectedFiles) {
  //   //   formData.append('document', rowData.uploadedFile);
  //   // }
  // console.log(rowData)
  //   this.api.putAPI(`/revenue/benchmark-details/${rowData.id}/`, formData).subscribe({
  //     next: (res) => {
  //       this.messageService.add({ severity: 'success', summary: 'Submitted', detail: 'Documents uploaded successfully' });
  //       // Clear uploaded files if needed
  //       this.selectedFiles = {};
  //       // this.editing
  //      this.table.cancelRowEdit(rowData); // Exit edit mode
  //       this.fetchBenchmarkData();
  //     },
  //     error: (err) => {
  //       this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Upload failed' });
  //     }
  //   });
  // }

  // onRowEditCancel(rowData: any, index: number) {
  //   // Revert to original data
  //   if (rowData.originalData) {
  //     this.vendors[index] = { ...rowData.originalData };
  //   }
  // }
  onFileUpload(event: any, rowData: any): void {
    const file = event.target.files[0];
    if (file) {
      rowData.uploadedFile = file;
      rowData.uploadedFileName = file.name;
      // Optional: Upload to server here or store temporarily
      // console.log('File selected:', file.name);
    }
  }


  selectedFiles: any
  onFileSelect(event: any,) {
    const file = event.files[0];
    if (file) {
      this.selectedFiles = file;

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: `File attached successfully`
      });
    }
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }

  showAddDialog: boolean = false;
  editIndex: number | null = null;

  newVendor: any = {
    vendor: { name: '', address: '' },
    benchmarkPrice: null,
    document: null,
    file: null
  };

  selectedVendor: any
  // Open add/edit dialog
  onEditVendor(row: any, index: number) {
    this.isEditMode = true;
    this.editIndex = index;
    // this.newVendor = {
    //   vendor: { ...row.vendor },
    //   benchmarkPrice: row.benchmarkPrice,
    //   document: row.document,
    //   file: row.file
    // };
    this.selectedVendor = row
    this.vendorForm.patchValue({
      document: row.document,
      vendor_name: row.vendor_name,
      vendor_address: row.vendor_address,
      benchmark_price: row.benchmark_price,
      bid_opening_date: row.bid_opening_date,
      bid_opening_time: row.bid_opening_time,
      vendorId: row.vendor_id
    }
    );
    this.vendorForm.get('document')?.setValue(row.document); // works if it's a string reference

    this.showAddDialog = true;

  }

  // Handle file upload
  onNewVendorFileUpload(event: any) {
    const file = event.target.files[0];
    const maxSizeBytes = 200 * 1024 * 1024; // 200 MB

    if (file.size > maxSizeBytes) {
      this.messageService.add({
        severity: 'error',
        summary: 'File Too Large',
        detail: `Maximum allowed file size is 200MB.`,
      });
      event.target.value = ''; // Reset the input
      return;
    }
    if (file) {
      this.vendorForm.patchValue({ document: file });
      this.vendorForm.get('document')?.setValue(file);
    }
  }
  showAddDialogPopup() {
    this.vendorForm.reset();
    this.vendorForm.value.document = null
    this.vendorForm.value.name = '';
     this.vendorForm.get('document')?.setValue(null);
      if (this.fileInput) {
    this.fileInput.nativeElement.value = '';
  }
    this.showAddDialog = true;
  }
  // Submit handler for both Add and Edit
  submitVendor() {
    const formData = new FormData();

    formData.append('proposal_step', this.step.id);
    formData.append('vendor_name', this.vendorForm.value.vendor_name);
    formData.append('vendor_address', this.vendorForm.value.vendor_address);
    formData.append('benchmark_price', this.vendorForm.value.benchmark_price);
    formData.append('bid_opening_date', this.vendorForm.value.bid_opening_date);
    formData.append('bid_opening_time', this.vendorForm.value.bid_opening_time);
    formData.append('single_vendor', "true");

    // Only append file if it's a File (i.e., newly selected)
    if (this.vendorForm.value.document instanceof File) {
      formData.append('document', this.vendorForm.value.document);
    }

    // Append vendor_id if exists (editing scenario)
    if (this.selectedVendor) {
      formData.append('vendor_id', this.selectedVendor.id);
    }

    const request$ = this.selectedVendor?.id
      ? this.api.putAPI(`/revenue/benchmark-details/${this.resId}/`, formData)
      : this.api.postAPI('/revenue/benchmark-details/', formData);

    request$.subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Vendor saved successfully' });
        this.showAddDialog = false;
        this.fetchBenchmarkData();
        this.vendorForm.reset();
         this.vendorForm.get('document')?.setValue(null);
        this.vendorForm.value.document = null
        this.vendorForm.value.name = ''
         if (this.fileInput) {
    this.fileInput.nativeElement.value = '';
  }
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save vendor' });
      }
    });
  }


  // Reset form data
  resetVendorForm() {
    this.newVendor = {
      vendor: { name: '', address: '' },
      benchmarkPrice: null,
      document: null,
      file: null
    };
    this.showAddDialog = false;
    this.isEditMode = false;
    this.editIndex = null;
  }

  submitProposalData() {
    const payload: any = {
      proposal_step: this.step.id,
      base_price: this.benchmarkForm.get('benchmark_price')?.value,
      bid_opening_date: this.benchmarkForm.get('bid_opening_date')?.value,
      bid_opening_time: this.benchmarkForm.get('bid_opening_time')?.value,
      justification: this.benchmarkForm.get('comment')?.value,
      technical_bid_venue : this.benchmarkForm.get('technical_bid_venue')?.value,
      benchmark_dates: this.benchmarkDates.map(row => ({
        name: row.name || '',
        date: row.date || ''
      }))
    };

    if (this.resId) {
      this.api.putAPI(`/revenue/benchmark-details/${this.resId}/`, payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Submitted successfully' });
          this.fetchBenchmarkData(); // reload or refresh
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to submit' });
        }
      });
    } else {
      this.api.postAPI(`/revenue/benchmark-details/`, payload).subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Submitted successfully' });
          this.fetchBenchmarkData(); // reload or refresh
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to submit' });
        }
      });
    }
  }

  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "Comments", value: this.benchmarkForm.get('comment')?.value },

      ]
    };
    this.generatePDFEmitter.emit(payload);
  }

  addBenchmarkDateRow() {
    if (!this.benchmarkDates) {
      this.benchmarkDates = [];
    }
    this.benchmarkDates.push({ 
      sequence: '', 
      name: '', 
      date: '', 
      edit: true 
    });
  }

  saveBenchmarkDateRow(row: any) {
   
    // Validate required fields
    if (!row.name || !row.date) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'Name and Date are required fields'
      });
      return;
    }

    // Check if this is an update (row has id) or create (new row)
    if (row.id) {
      // Update existing record
      const payload = {
        name: row.name,
        date: row.date
      };
      
      this.api.putAPI(`/revenue/benchmark-dates/${row.id}/`, payload).subscribe({
        next: (res: any) => {
          row.edit = false; // Exit edit mode
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Benchmark date updated successfully'
          });
          this.fetchBenchmarkData(); // Refresh data
        },
        error: (err) => {
          console.error('Error updating benchmark date:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || err?.error?.message || 'Failed to update benchmark date'
          });
        }
      });
    } else {
      // Create new record
      if (!this.resId) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Benchmark details not found. Please save the main form first.'
        });
        return;
      }

      const payload = {
        benchmark: this.resId,
        name: row.name,
        date: row.date
      };

      this.api.postAPI('/revenue/benchmark-dates/', payload).subscribe({
        next: (res: any) => {
          row.edit = false; // Exit edit mode
          // Update the row with the returned id
          if (res.id) {
            row.id = res.id;
          }
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Benchmark date created successfully'
          });
          this.fetchBenchmarkData(); // Refresh data
        },
        error: (err) => {
          console.error('Error creating benchmark date:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || err?.error?.message || 'Failed to create benchmark date'
          });
        }
      });
    }
  }

}


// interface Vendor {
//   id: number;
//   name: string;
//   address: string;
//   benchmarkPrice?: number;
//   justification?: string;
//   remark?:string
// }
